import { Link } from 'react-router-dom';
import notfound from './../../assets/images/404.png';

export default function NotFound() {
    return (
        <div className='d-black text-center justify-content-center align-content-center'>
            <h1 className='text-center mt-5 mb-3'>صفحه مورد نظر یافت نشد</h1>
            <Link to='/' className='btn btn-success btn-rounded btn-fw ' >بازگشت به پنل</Link>
            <img src={notfound} alt="notfound" width='100%' height='auto' />
        </div>
    )
}
